
// Vue
import { Prop, Watch } from 'vue-property-decorator';
import { Component, Mixins } from 'vue-mixin-decorator';
// Components
import BasePage from '@/pages/BasePage.vue';

import 'tippy.js/dist/tippy.css';

import moment from 'moment';

/**
 * [SFR0005] 商品詳細 - エンドポイントタブコンポーネント
 */
@Component
export default class ProductDetailEndpoint extends Mixins<BasePage>(BasePage) {
  private apiKey = '';
  private subscriptionStatus = false;
  private loggedin = false;
  private lastModifiedDateTime = '';

  /** API定義ファイルURL */
  @Prop({ default: '' })
  url!: string;
  @Watch('url')
  private watchUrl() {
    //URLの変更にしたがって、SwaggerUIにも更新をかける
    this.updateSwaggerUI();
  }

  updateSwaggerUI() {
    const modelsNotDisplay = this.url.includes('passenger') ? -1 : 1;
    // swagger uiで表示
    const SwaggerUI = require('swagger-ui');

    const apiKey = this.apiKey;

    const DisableUrlPlugin = function() {
      return {
        statePlugins: {
          spec: {
            wrapSelectors: {
              url: () => () => false
            }
          }
        }
      };
    };

    // Authorizeは無効化
    const DisableAuthorizePlugin = function() {
      return {
        wrapComponents: {
          authorizeBtn: () => () => null
        }
      };
    };

    const showMessage = this.showInfoMessage;
    const swaggerUrl = this.url;
    const messageRequested = this.$t(
      'pages.productDetailEndpoint.message.apiRequested'
    ).toString();
    const interceptor = function(r: any) {
      if (apiKey != '' && r.url != swaggerUrl) {
        r.headers['X-MONET-APIKey'] = apiKey;
        showMessage(messageRequested);
      }
      return r;
    };
    SwaggerUI({
      url: this.url,
      dom_id: `#${this.$style.endpoint}`,
      defaultModelsExpandDepth: modelsNotDisplay,
      presets: [SwaggerUI.presets.apis, SwaggerUI.SwaggerUIStandalonePreset],
      plugins: [DisableUrlPlugin, DisableAuthorizePlugin],
      requestInterceptor: interceptor
    });

    const data = new XMLHttpRequest();
    data.open('GET', this.url, false);
    data.send(null);
    const date = data.getResponseHeader('last-modified');
    this.lastModifiedDateTime =
      date != null
        ? moment(date)
            .tz('Asia/Tokyo')
            .format('YYYY-MM-DD hh:mm')
        : '';
  }

  async mounted() {
    this.store.showLoader();
    this.updateSwaggerUI();

    //try-it-out を disabled にする
    let els = document.getElementsByClassName('swagger-ui');
    for (var i = 0, len = els.length | 0; i < len; i = (i + 1) | 0) {
      let el = els[i];

      const observer = new MutationObserver(mutations => {
        mutations.forEach((): void => {
          let btns = document.getElementsByClassName('btn try-out__btn');
          for (var j = 0, len = btns.length | 0; j < len; j = (j + 1) | 0) {
            let btn = btns[j] as HTMLButtonElement;
            btn.disabled = true;
          }
        });
      });

      const config = {
        attributes: false,
        childList: true,
        characterData: false,
        subtree: true
      };

      observer.observe(el, config);
    }

    this.store.hideLoader();
  }
}
